import useGetPaymentProviderStatusQuery from '@/api/queries/useGetPaymentProviderStatusQuery';
import { isBillingEnabledFor } from '@/config';
import {
  BillingDetailsEditPath,
  BillingHomePath,
  BillingPaymentMethodAddPath,
  BillingPaymentMethodListPath,
} from '@/modules/billing/paths';
// import { ProductListPath } from '@/modules/product/paths';
import { default as BaseSettings, Section } from '@/modules/settings/pages/Settings';
import { StoreSettingsPath } from '@/modules/store/paths';
import {
  BuildingOfficeIcon,
  BuildingStorefrontIcon,
  CreditCardIcon,
  // CubeIcon,
  LockClosedIcon,
  TruckIcon,
  UserIcon,
} from '@heroicons/react/24/outline';
import { Outlet } from 'react-router-dom';

const isSection = (value: Section | undefined): value is Section => Boolean(value);

const sections: (paymentProviderStatus?: boolean) => Section[] = (paymentProviderStatus) =>
  [
    {
      href: StoreSettingsPath.profile,
      title: 'Profile',
      icon: UserIcon,
      children: [
        { href: StoreSettingsPath.profile, title: 'Profile', icon: UserIcon },
        // {href: RetailerSettingsPath.notification, title: 'Notifications', icon: BellIcon},
        // {href: RetailerSettingsPath.currency, title: 'Currency', icon: CurrencyDollarIcon},
        // {href: RetailerSettingsPath.language, title: 'Language', icon: LanguageIcon},
        {
          href: StoreSettingsPath.password,
          title: 'Change Password',
          icon: LockClosedIcon,
        },
        {
          href: StoreSettingsPath.businessAddress,
          title: 'Business Address',
          icon: BuildingOfficeIcon,
        },
        {
          href: StoreSettingsPath.deliveryAddress,
          title: 'Delivery Address',
          icon: BuildingStorefrontIcon,
        },
      ],
    },
    paymentProviderStatus && isBillingEnabledFor('store')
      ? {
          href: BillingHomePath,
          title: 'Billing',
          icon: CreditCardIcon,
          children: [
            {
              href: BillingHomePath,
              title: 'Billing',
              icon: CreditCardIcon,
              children: [
                {
                  href: BillingDetailsEditPath,
                  title: 'Edit Billing Details',
                  icon: CreditCardIcon,
                },
              ],
            },
            {
              href: BillingPaymentMethodListPath,
              title: 'Payment Methods',
              icon: CreditCardIcon,
              children: [
                {
                  href: BillingPaymentMethodAddPath,
                  title: 'Add Payment Method',
                  icon: CreditCardIcon,
                },
              ],
            },
          ],
        }
      : undefined,
    { href: StoreSettingsPath.supplier, title: 'Suppliers', icon: TruckIcon },
    // { href: ProductListPath, title: 'Products', icon: CubeIcon },
  ].filter(isSection);

export const Settings = () => {
  const { status: paymentProviderStatus, isLoading } = useGetPaymentProviderStatusQuery();

  if (isLoading) {
    return;
  }

  return (
    <BaseSettings sections={sections(paymentProviderStatus?.available)}>
      <Outlet />
    </BaseSettings>
  );
};

export default Settings;
